import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StepExceptionTaxState } from "./type";

const INITIAL_STATE: StepExceptionTaxState = {
  step: 1,
};

const stepExceptionTaxSlice = createSlice({
  name: "stepExceptionTax",
  initialState: INITIAL_STATE,
  reducers: {
    nextStep(state) {
      state.step += 1;
    },
    prevStep(state) {
      if (state.step > 1) state.step -= 1;
    },
    setStep(state, action: PayloadAction<number>) {
      state.step = action.payload;
    },
    resetStep() {
      return INITIAL_STATE;
    },
  },
});

export const { nextStep, prevStep, setStep, resetStep } =
  stepExceptionTaxSlice.actions;
export default stepExceptionTaxSlice.reducer;
